<template>
  <!-- Your Page Content Goes Here-->
    <div class="page-content header-clear-medium">

		<div>
			<div class="d-flex justify-content-center">
				<div class="preloader-l">
					<div class="spinner-border color-blue-dark" style="border-width: 7px;" role="status"></div>
				</div>
			</div>
		</div>

    </div>
	<!-- End of Page Content-->
</template>

<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex'

export default {
    name: 'Login',
    data() {
        return {
			data: {
				nis: this.$route.query.nis,
				token: this.$route.query.token
			}
		}
    },
	created() {
		if (this.isAuth) {
			this.$router.push({name: 'home'})
		} else {
			this.login()
		}
	},    
	computed: {
		...mapGetters(['isAuth']),
		...mapState(['errors'])
	},
	methods: {
		...mapActions('auth', ['submitToken']),
		...mapMutations(['CLEAR_ERRORS']),
		login() {
			this.status_login = true
			this.submitToken(this.data)
				.then(() => {
					if (this.isAuth) {
						this.CLEAR_ERRORS()
						this.$router.push({ name: 'home' })
					}
				})
		},
	},
}
</script>